import React from "react";
import classNames from "classnames";
import { BemHelper } from "../utils/BemHelper";
import { currencyFormat, useBreakpointValue } from "../utils";
import { truncateHtmlToPlainText } from "../utils/stringHelpers";
import defaultImage from "./images/default-product.jpeg";
import { Col, Row, Typography } from "antd";

type Props = {
  name: string;
  price: number | string;
  description: string;
  cohort?: string | null;
  image?: string;
  topActions?: React.ReactNode;
  bottomActions?: React.ReactNode;
  hidePrice?: boolean;
  isPrivate?: boolean;
  onClick?: () => void;
  onImageClick?: () => void;
  highlight?: boolean;
  disabled?: boolean;
  disabledChildren?: React.ReactNode;
};

const bem = new BemHelper("product-card");

export const ProductCard: React.FC<Props> = ({
  name,
  price,
  description,
  cohort,
  image,
  topActions,
  bottomActions,
  hidePrice,
  onClick,
  isPrivate,
  highlight,
  onImageClick,
  disabled = false,
  disabledChildren,
}) => {
  const isMobile = useBreakpointValue({ base: false, xs: true });
  return (
    <div className={classNames(bem.block(), highlight && bem.modifier("highlighted"))}>
      {disabled && disabledChildren && parseFloat(price.toString()) !== 0 && (
        <div className={classNames(disabled && bem.element("block-box"))}>{disabledChildren}</div>
      )}
      <div
        className={classNames(
          bem.element("image"),
          isMobile && bem.element("image-mobile"),
          onImageClick && bem.modifier("has-actions"),
          disabled && parseFloat(price.toString()) !== 0 && bem.element("disabled"),
        )}
        onClick={() => onImageClick && onImageClick()}
      >
        <img src={image || defaultImage} />
      </div>
      <div
        className={classNames(
          bem.element("content"),
          isMobile && bem.modifier("mobile-content"),
          disabled && parseFloat(price.toString()) !== 0 && bem.element("disabled"),
        )}
      >
        <div className={classNames(bem.element("header"))}>
          {!hidePrice && (
            <div className={classNames(bem.element("price"))}>
              {parseFloat(price.toString()) !== 0 ? currencyFormat(price) : "FREE"}
            </div>
          )}

          {isPrivate && !disabled && <div className={classNames(bem.element("tag"))}>Hidden</div>}
          {/* {parseFloat(price.toString()) === 0 && !hidePrice && !isMobile && (
            <div className={classNames(bem.element("tag"))}>Complementary</div>
          )} */}
          {isMobile && topActions}
        </div>
        <Row onClick={() => onClick && onClick()}>
          <Col>
            <Typography.Paragraph
              className={classNames(
                bem.element("title"),
                isMobile && bem.modifier("mobile", "title"),
                onClick && bem.modifier("has-actions"),
              )}
              ellipsis={{ rows: 2, expandable: false, symbol: "..." }}
              style={{ marginBottom: 0 }}
            >
              {name}
            </Typography.Paragraph>
          </Col>
        </Row>

        {!isMobile && cohort && (
          <div className={classNames(bem.element("cohort"))}>
            <b>{`Cohort: `}</b>
            <span>{cohort}</span>
          </div>
        )}
        {!isMobile && (
          <div
            className={classNames(bem.element("description"))}
            dangerouslySetInnerHTML={{ __html: truncateHtmlToPlainText(description, 250) }}
          />
        )}
        {isMobile && bottomActions && (
          <div className={classNames(bem.element("mobile-cta"))}>{bottomActions}</div>
        )}
      </div>
      {(topActions || bottomActions) && !isMobile && (
        <div className={classNames(bem.element("actions"))}>
          <div>{!disabled && topActions}</div>
          <div
            className={classNames(
              bem.element("outside-actions"),
              disabled && bem.element("disabled"),
            )}
          >
            {!isMobile && bottomActions}
          </div>
        </div>
      )}
    </div>
  );
};
